import cn from "clsx";
import { jsx as _jsx } from "react/jsx-runtime";
var Container = function Container(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/_jsx("section", {
    className: cn('tw-px-1.6 tw-py-3.2',
    // Border
    'tw-border tw-border-solid tw-border-neutral-light-400 dark:tw-border-neutral-dark-700',
    // Rounded
    'tw-rounded-1',
    // Background
    'tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-01',
    // Shadow
    'tw-shadow-01 dark:tw-shadow-none', className),
    children: children
  });
};
export default Container;